import { render, staticRenderFns } from "./bottleInfo.vue?vue&type=template&id=19fc1b7c&"
import script from "./bottleInfo.vue?vue&type=script&lang=js&"
export * from "./bottleInfo.vue?vue&type=script&lang=js&"
import style0 from "./bottleInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports